import {
    combineReducers,
} from 'redux-immutable';
import Immutable from 'immutable';
import {
    createImmutableReducer,
} from '@shared/common';
import actions from '../actions';

const reduceUpdateById = (state, {payload: {updated, deleted}}) => {
    if (updated) {
        updated.forEach(entity => {
            const original = state.getIn(['byId', entity.id]);
            state.setIn(['byId', entity.id], Immutable.fromJS(Object.assign(original ? original.toJS() : {}, entity)));
        });
    }
    if (deleted) {
        deleted.forEach(entity_id => {
            state.removeIn(['byId', entity_id]);
        });
    }
    return state;
};

export default combineReducers({
    tour: createImmutableReducer(
        {
            id: window.tour_editor.tour_id,
            byId: {},
        },
        {
            [actions.data.tour.updated]: reduceUpdateById,
        },
    ),
    floor: createImmutableReducer(
        {
            byId: {},
        },
        {
            [actions.data.floor.updated]: reduceUpdateById,
        },
    ),
    room: createImmutableReducer(
        {
            byId: {},
        },
        {
            [actions.data.room.updated]: reduceUpdateById,
        },
    ),
    infopoint: createImmutableReducer(
        {
            byId: {},
        },
        {
            [actions.data.infopoint.updated]: reduceUpdateById,
        },
    ),
    global: createImmutableReducer(
        {},
        {
            [actions.data.global.updated]: (state, {payload: {base_url, base_url_embed}}) => {
                state
                    .set('base_url', base_url)
                    .set('base_url_embed', base_url_embed)
                ;
            },
        },
    ),
});
